/**
 * Aigen AI-Generated Content — Interactive Components
 * Uses event delegation for reliability inside <details> elements.
 */

(function () {
  'use strict';

  document.addEventListener('click', function (e) {

    /* ── Lighting Comparison ─────────────────────────────────────────── */

    var thumb = e.target.closest('.aigen-lighting__thumb');
    if (thumb) {
      e.preventDefault();
      var container = thumb.closest('[data-aigen-lighting]');
      if (!container) return;

      // Update active state
      container.querySelectorAll('.aigen-lighting__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');

      // Update preview image
      var imgUrl = thumb.getAttribute('data-image');
      var lightLabel = thumb.getAttribute('data-label');
      var lightColor = thumb.getAttribute('data-color');

      var preview = container.querySelector('.aigen-lighting__preview img');
      if (preview && imgUrl) {
        preview.src = imgUrl + '&width=900';
        preview.alt = lightLabel;
      }

      var label = container.querySelector('.aigen-lighting__overlay-label');
      if (label) {
        label.textContent = lightLabel;
      }

      container.style.setProperty('--light-accent', lightColor);
      return;
    }

    /* ── Product Attributes ──────────────────────────────────────────── */

    var attr = e.target.closest('.aigen-attr');
    if (attr) {
      var wasExpanded = attr.classList.contains('is-expanded');

      // Collapse all
      document.querySelectorAll('.aigen-attr.is-expanded').forEach(function (el) {
        el.classList.remove('is-expanded');
      });

      // Toggle clicked
      if (!wasExpanded) {
        attr.classList.add('is-expanded');
      }
      return;
    }

  });

  /* ── Swatch Colors Custom Element ──────────────────────────────── */
  if (!customElements.get('aigen-swatch-colors')) {
    customElements.define('aigen-swatch-colors', class extends HTMLElement {
      connectedCallback() {
        if (typeof window.applyAigenSwatchColors === 'function') {
          window.applyAigenSwatchColors();
        }
      }
    });
  }

}());
